import type { CourseUrl, SemesterId } from '/imports/domain';
import type { AccessCode } from '/imports/modules/Invitations/domain/AccessCode';
import { AccessCodeC } from '/imports/modules/Invitations/domain/AccessCode';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';
import { pathToUrl } from '/imports/ui/helper/url';
import type { ListInvitationsSection } from '/imports/ui/pages/myCourses/routes';
import { listInvitationsRoute } from '/imports/ui/pages/myCourses/routes';

export const handleInvitationRoute = url(
  lit('invitations'),
  lit('accept'),
  type('accessCode', AccessCodeC),
  end,
);

export const formatHandleInvitationsUrl = (accessCode: AccessCode) =>
  pathToUrl(formatRoute(handleInvitationRoute)({ accessCode }));

export const formatListInvitationsUrl = ({
  semester,
  courseUrl,
  section = 'pending',
}: {
  semester: SemesterId;
  courseUrl: CourseUrl;
  section?: ListInvitationsSection;
}): string => formatRoute(listInvitationsRoute)({ semester, courseUrl, section });
